export const CHANGE_HEADER_TITLE = "CHANGE_HEADER_TITLE";

export const SET_CURRENT_USER_INFO = "SET_CURRENT_USER_INFO";

export const SET_OFFLINE_DATASOURCE_INFO = "SET_OFFLINE_DATASOURCE_INFO";

export const UPDATE_OFFLINE_DATASOURCE_FIELD = "UPDATE_OFFLINE_DATASOURCE_FIELD";

export const UPDATE_OFFLINE_MAPPING_DATA_SOURCE_VIEW_NEXT_BTN_DATA = "UPDATE_OFFLINE_MAPPING_DATA_SOURCE_VIEW_NEXT_BTN_DATA";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
